import React from 'react';
import { resolveApiAssetUrl } from '../lib/api';
import { isVideoAsset } from '../lib/mediaAsset';

// Görsel ya da hareketli kart (MP4/WEBM) çizen küçük kapı.
//
// `GameArtwork`'ten farkı yedek görünümü **olmamasıdır**: çağıran taraflar
// (panel listeleri, arama sonucu, oyun seçim penceresi) adres boşken zaten
// kendi boş-durum ikonlarını çiziyor ve ortak bir yedek onların düzenini
// bozardı. Ortak olan tek şey karardır: `<img src="...mp4">` hiçbir
// tarayıcıda çizilmez, o yüzden oyun görselini doğrudan `<img>` ile
// yazmayın.
// Kalan nitelikler (`data-bhs-*` gibi DOM kimlikleri) çizilen öğeye geçer.
const MediaThumb = ({ src, alt = '', className, loading = 'lazy', ...rest }) => {
  const resolved = resolveApiAssetUrl(src);
  if (!resolved) return null;

  if (isVideoAsset(resolved)) {
    // Kontrolsüz, sessiz ve döngülü: kart bir dekordur. `muted` +
    // `playsInline` olmadan mobil tarayıcılar otomatik oynatmayı reddeder.
    return (
      <video
        src={resolved}
        className={className}
        aria-label={alt || undefined}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        {...rest}
      />
    );
  }

  return <img src={resolved} alt={alt} className={className} loading={loading} {...rest} />;
};

export default MediaThumb;
